import { useQuery } from '@tanstack/react-query'
import api from '../../api'

const useMongoDBEligibility = (applicationID: string) =>
	useQuery({
		queryKey: ['mongodb-eligibility', applicationID],
		queryFn: () => api.mongodb.getMongoDBEligibility(applicationID),
		select(data) {
			const [eligibility] = data.body
			if (!eligibility) {
				throw new Error('Unable to check Application eligibility.')
			}
			return eligibility
		},
		enabled: Boolean(applicationID),
		retry: false
	})

export default useMongoDBEligibility
